import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { cn } from '../../lib/utils';

type WorkflowRightPanelProps = {
    title: string;
    description?: string;
    defaultOpen?: boolean;
    className?: string;
    children: React.ReactNode;
};

export const WorkflowRightPanel: React.FC<WorkflowRightPanelProps> = ({
    title,
    description,
    defaultOpen = true,
    className,
    children,
}) => {
    return (
        <Accordion
            type="single"
            collapsible
            defaultValue={defaultOpen ? 'workflow' : undefined}
            className={cn('w-full', className)}
        >
            <AccordionItem value="workflow" className="border rounded-md bg-white shadow-sm overflow-hidden">
                <AccordionTrigger className="px-4 py-2 hover:no-underline hover:bg-slate-50 transition-colors">
                    <div className="flex flex-col items-start text-left">
                        <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{title}</span>
                        {description ? (
                            <span className="text-[11px] text-slate-500">{description}</span>
                        ) : null}
                    </div>
                </AccordionTrigger>
                <AccordionContent className="px-4 pb-4 pt-2">
                    <div className="space-y-3">{children}</div>
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
};
